"use strict";
/**
 * Locked ID Scorecard copy from the Renovation Consumer Confidence Score tool doc.
 * Bump `SCORECARD_COPY_VERSION` when Product changes wording.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCORECARD_ALL_YES_WRITING_COPY = exports.SCORECARD_ESCROW_COPY = exports.SCORECARD_THING_COPY = exports.SCORECARD_BAND_LABELS = exports.SCORECARD_MOSTLY_NOT_SURE_CAVEAT = exports.SCORECARD_ALL_YES_WRITING_TITLE = exports.SCORECARD_ESCROW_DISPLAY_TITLE = exports.SCORECARD_COPY_VERSION = void 0;
exports.fillIdPlaceholder = fillIdPlaceholder;
exports.SCORECARD_COPY_VERSION = "2026-10-23";
/** Display title for Escrow Payment on things-to-check lists. */
exports.SCORECARD_ESCROW_DISPLAY_TITLE = "How You'll Pay";
/** Display title for the all-Yes first last-step. */
exports.SCORECARD_ALL_YES_WRITING_TITLE = "Get Everything in Writing";
exports.SCORECARD_MOSTLY_NOT_SURE_CAVEAT = "Most of your answers were Not sure yet, so this score says more about what you haven't seen yet than about the ID";
exports.SCORECARD_BAND_LABELS = {
    strong_confidence: "Strong Confidence",
    investigate_further: "Investigate Further",
    slow_down: "Slow Down Before Signing",
};
/** Non-escrow things-to-check copy (same for Partially / No / Not sure yet). */
exports.SCORECARD_THING_COPY = {
    "Getting Started": {
        whatsUnclear: "Their first contact didn't feel easy.",
        recommendation: "Notice how quickly and clearly they reply over the next few days. It's how they'll communicate during the project.",
        question: "How will we keep in touch during the project, and how quickly do you usually reply?",
    },
    "Understand Your Needs": {
        whatsUnclear: "They may have missed parts of your brief.",
        recommendation: "Send them your must-haves in writing and ask them to confirm how the design covers each one.",
        question: "Could you confirm how the design covers each item on my list of must-haves?",
    },
    "Professional Advice": {
        whatsUnclear: "Some of their advice didn't feel practical or clear.",
        recommendation: "Ask them to walk you through the options for your budget, and what they'd do differently in your home.",
        question: "Could you take me through the options for my budget, and what you'd recommend for my home?",
    },
    "Design Fit": {
        whatsUnclear: "The design doesn't fully suit how you live yet.",
        recommendation: "List what doesn't work for your routine and ask for a revised layout before you sign.",
        question: "Could we revise the layout to fit how we use the space day to day?",
    },
    "Project Monitoring": {
        whatsUnclear: "You don't know yet who will look after your site or how you'll hear about progress.",
        recommendation: "Find out who your site supervisor will be and how often you'll get updates, then get it in writing.",
        question: "Who will supervise my site, and how often will I get progress updates?",
    },
    "Commitment Confidence": {
        whatsUnclear: "Parts of the quote or contract aren't clear yet.",
        recommendation: "Go through the quotation line by line before you sign. Find out which items are still KIV (to be confirmed later), and get every warranty written into the contract.",
        question: "Could we go through the quotation item by item? Which items are still KIV, and which warranties will be written into the contract?",
    },
    "Quality Showcase": {
        whatsUnclear: "You haven't seen finished work that matches what you want.",
        recommendation: "Ask to see photos of completed projects like yours, or arrange to visit one. It's the clearest way to see the standard you'll get.",
        question: "Could you share photos of 2 or 3 completed projects like mine, or arrange for me to visit one?",
    },
    "Trust & Credentials": {
        whatsUnclear: "You haven't checked their accreditations yet.",
        recommendation: "Check HDB's Directory of Renovation Contractors and the CaseTrust list yourself. It takes a minute. You can also ask them directly.",
        question: "Are you CaseTrust-accredited and listed in HDB's Directory of Renovation Contractors?",
    },
    "Hausmark Confidence": {
        whatsUnclear: "It isn't clear yet whether they hold a Hausmark Seal.",
        recommendation: "Look them up in Hausmark's published assessment reports, or ask them directly.",
        question: "Have you been assessed for the Hausmark Seal of Excellence?",
    },
    "Online Presence": {
        whatsUnclear: "Their reviews don't give you confidence yet.",
        recommendation: "Read recent reviews on Google and renovation forums, and ask to speak to a past client.",
        question: "Could I speak to a homeowner you've worked with recently?",
    },
};
/** How You'll Pay — four versions by escrow answer. `[ID]` is replaced with the ID name. */
exports.SCORECARD_ESCROW_COPY = {
    yes: {
        whatsUnclear: "Nothing unclear. Always shown.",
        recommendation: "[ID] accepts escrow. Invite them to Handshake so your money is held in escrow, in a DBS custodian account, and released to them only on your approval.",
        question: "You mentioned you accept escrow. Could we use Handshake for my renovation payments?",
    },
    partially: {
        whatsUnclear: "They're open to escrow, but you haven't agreed how you'll pay yet.",
        recommendation: "Use Handshake for your renovation payments. Your money is held in escrow, in a DBS custodian account, and released to [ID] only on your approval.",
        question: "You mentioned you're open to escrow. Could we use Handshake for my renovation payments? The money is held in escrow, in a DBS custodian account, and released to you as I approve each stage.",
    },
    not_sure: {
        whatsUnclear: "You don't know yet whether they'll accept escrow.",
        recommendation: "Ask if [ID] will use Handshake for your payments. Your money is held in escrow, in a DBS custodian account, and released to them only on your approval.",
        question: "Would you be open to using Handshake for my renovation payments? The money is held in escrow, in a DBS custodian account, and released to you as I approve each stage.",
    },
    no: {
        whatsUnclear: "They don't use escrow today.",
        recommendation: "Many IDs simply haven't been asked. With Handshake, [ID] is paid in stages as the work gets done, and your money is held in escrow, in a DBS custodian account, until then. Ask if they'd consider it.",
        question: "Would you consider using Handshake for my renovation payments? The money is held in escrow, in a DBS custodian account, and released to you as I approve each stage.",
    },
};
/** All-Yes first last-step (paired with How You'll Pay yes). */
exports.SCORECARD_ALL_YES_WRITING_COPY = {
    whatsUnclear: "Nothing unclear from your answers.",
    recommendation: "Check that everything you discussed is in the final quotation and contract, item by item, before you pay a deposit.",
    question: "Could you send me the final quotation and contract to review?",
};
function fillIdPlaceholder(template, idName) {
    // Function replacer so `$`, `$&`, `$$` in the ID name are not treated as replace patterns.
    return template.replaceAll("[ID]", () => idName);
}
